const TimeEdit = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.784 3.794a8.5 8.5 0 0 1 10.482 6.226.5.5 0 0 1-.972.233 7.5 7.5 0 1 0-8.873 9.079.5.5 0 1 1-.21.978 8.5 8.5 0 0 1-.427-16.516"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.5 11.792V7.5a.48.48 0 0 0-.144-.356.49.49 0 0 0-.357-.144.48.48 0 0 0-.356.144.49.49 0 0 0-.143.356v4.379q0 .152.056.297a.8.8 0 0 0 .186.274l1.843 1.843a.5.5 0 0 0 .344.15.47.47 0 0 0 .364-.15.5.5 0 0 0 .16-.354.5.5 0 0 0-.16-.354z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.183 13.891a.5.5 0 0 0-.707 0l-5.55 5.55-.177.884.884-.177 5.55-5.55a.5.5 0 0 0 0-.707m-1.414-.707a1.5 1.5 0 0 1 2.12 2.122l-5.549 5.55a1 1 0 0 1-.51.273l-1.252.25a.75.75 0 0 1-.883-.883l.25-1.251a1 1 0 0 1 .274-.511z"
      clipRule="evenodd"
    />
  </>
)
export default TimeEdit
